import React from 'react';

import { MicrositeHeader } from '@latitude/microsite-header-rebrand';
import { BREAKPOINT } from '@latitude/core/utils/constants';

const APPLY_NOW_URL = '#limited-time-offer-selector';

const DATA = [
  {
    id: 'home',
    label: 'Home',
    trackId: 'nav-home',
    href: '/credit-cards/low-rate/'
  },
  {
    id: 'c2p',
    label: 'Click to Pay',
    trackId: 'nav-c2p',
    href: '/click-to-pay/'
  },
  {
    id: 'faqs',
    label: 'FAQs',
    trackId: 'nav-faqs',
    href: '/credit-cards/low-rate/faqs/'
  },
  {
    id: 'help',
    label: 'Help',
    trackId: 'nav-help',
    href: 'https://latitudefs.zendesk.com/hc/en-au/'
  }
];

function LowRateMicrositeHeader({ applyNowUrl = APPLY_NOW_URL }) {
  return (
    <div
      css={`
        .microsite-header__nav-wrap {
          @media (min-width:1600px) {
            max-width: 1400px !important;
          }
        }
        .microsite-header__nav-wrap > *:first-child p {
          @media (min-width: ${BREAKPOINT.MD}) {
            margin-left: 5px !important;
          }
        }
        .microsite-header__inner {
        position: absolute;
        width: 100%;
          top: 56px;
          @media (min-width: ${BREAKPOINT.LG}) {
            top: 80px;
          }
        }
        .microsite-header__nav-wrap > div:first-of-type > p {
          @media (min-width: ${BREAKPOINT.LG}) {
            width: 202px;
          }
        }
        .microsite-header-rebrand {
          z-index: 2000 !important;
        }
        .top-menu-item__label a {
          @media (max-width: ${BREAKPOINT.LG}) {
            border-bottom: none;
          }
        }
      `}
    >
      <MicrositeHeader
        data={DATA}
        microSiteName="Low Rate"
        ctaHref={applyNowUrl}
        ctaText="Make a selection"
      />
    </div>
  );
}

export default LowRateMicrositeHeader;
